import { render, staticRenderFns } from "./viewPromoCard.vue?vue&type=template&id=0e4140e4&scoped=true&"
import script from "./viewPromoCard.vue?vue&type=script&lang=js&"
export * from "./viewPromoCard.vue?vue&type=script&lang=js&"
import style0 from "./viewPromoCard.vue?vue&type=style&index=0&id=0e4140e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4140e4",
  null
  
)

export default component.exports